import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price) {
  return new Intl.NumberFormat('en-NZ', {
    style: 'currency',
    currency: 'NZD',
  }).format(price);
}

export function generateCartId() {
  const stored = localStorage.getItem('vshoppe_cart_id');
  if (stored) return stored;
  
  const newId = 'cart_' + Math.random().toString(36).substring(2, 15);
  localStorage.setItem('vshoppe_cart_id', newId);
  return newId;
}

export function generateWishlistId() {
  const stored = localStorage.getItem('vshoppe_wishlist_id');
  if (stored) return stored;
  
  const newId = 'wishlist_' + Math.random().toString(36).substring(2, 15);
  localStorage.setItem('vshoppe_wishlist_id', newId);
  return newId;
}

export function getToken() {
  return localStorage.getItem('vshoppe_token');
}

export function setToken(token) {
  localStorage.setItem('vshoppe_token', token);
}

export function removeToken() {
  localStorage.removeItem('vshoppe_token');
}

export function getUser() {
  const user = localStorage.getItem('vshoppe_user');
  return user ? JSON.parse(user) : null;
}

export function setUser(user) {
  localStorage.setItem('vshoppe_user', JSON.stringify(user));
}

export function removeUser() {
  localStorage.removeItem('vshoppe_user');
}

export function truncateText(text, maxLength) {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
}

export function getStarRating(rating) {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  
  for (let i = 0; i < fullStars; i++) {
    stars.push('full');
  }
  if (hasHalfStar && stars.length < 5) {
    stars.push('half');
  }
  while (stars.length < 5) {
    stars.push('empty');
  }
  
  return stars;
}
